import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, Outlet } from 'react-router';
import { CfAccessPrompt } from './CfAccessPrompt';
import { useAuthStore } from '@/stores/authStore';
export function RequireAuth() {
    const accessToken = useAuthStore((s) => s.accessToken);
    if (!accessToken) {
        return _jsx(CfAccessPrompt, {});
    }
    return _jsx(Outlet, {});
}
/**
 * Role-gate for a subset of staff routes. Pass the roles that ARE
 * allowed — a user holding any one of them passes. Non-matching users
 * are bounced back to /.
 *
 * Belt-and-braces: the sidebar already hides the link for out-of-role
 * users; this guard covers deep-links / typed-URL access. The real
 * boundary is the backend @PreAuthorize on /admin/* endpoints.
 */
export function RequireRole({ roles }) {
    const user = useAuthStore((s) => s.user);
    const ok = user?.roles?.some((r) => roles.includes(r)) ?? false;
    if (!ok)
        return _jsx(Navigate, { to: "/", replace: true });
    return _jsx(Outlet, {});
}
